<template>
  <div class="warehouseOperationLogList">
    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList(page + 1)"
    >
      <div
        class="list-container"
        v-for="(item, index) in tableData"
        :key="index"
      >
        <div class="left">
          <div class="list-item">
            {{ $t.warehouse.warehouseWorkNumber }}：{{
              item.WarehouseWorkNumber
            }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.warehouseExportNumber }}：{{ item.OutboundNumber }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.date }}：{{ item.CreateTime }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.operation }}：{{ item.OperationTypeStr }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.boxName }}：{{ item.BoxName }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.goodsNameSn }}：{{ item.ProductName }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.brand }}：{{ item.Brand }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.model }}：{{ item.Model }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.exportNumber }}：{{ item.OutboundQuantity }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.inventory }}：{{ item.InventoryQuantity }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.goodsValue }}：{{ item.UnitPrice }}
          </div>
          <div class="list-item">
            {{ $t.warehouse.long }}：{{ item.Long }} cm
          </div>
          <div class="list-item">
            {{ $t.warehouse.width }}：{{ item.Wide }} cm
          </div>
          <div class="list-item">
            {{ $t.warehouse.height }}：{{ item.Height }} cm
          </div>
          <div class="list-item">
            {{ $t.warehouse.storageDays }}：{{ item.StorageTime }}
            {{ $t.meta.day }}
          </div>
        </div>
        <div class="right">
          <div class="images">
            <van-image
              width="88"
              height="88"
              fit="cover"
              @click="imagePreview(imgUrlFilter(item.ProductPictures))"
              :src="imgUrlFilter(item.ProductPictures)"
              v-if="item.ProductPictures"
            />
            <span v-else>{{ $t.warehouse.noImage }}</span>
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { List, Image } from "vant";

import Vue from "vue";
Vue.use(List).use(Image);

export default {
  name: "warehouseOperationLogList",
  data() {
    return {
      warehouseWorkNumber: "",
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
    };
  },
  created() {
    const { WarehouseWorkNumber } = this.$route.query;
    this.warehouseWorkNumber = WarehouseWorkNumber;
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    getList(page) {
      var param = {
        PageIndex: page,
        PageSize: this.pageSize,
        WarehouseWorkNumber: this.warehouseWorkNumber,
      };
      this.$api.storage
        .getCargoOperationLogList(param)
        .then((res) => {
          this.tableData = this.tableData.concat(res.data.Data);
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.page = res.meta.page;
          this.finished = this.page >= res.meta.lastPage;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.warehouseOperationLogList {
  .list {
    .list-container {
      font-size: 12px;
      color: #333;
      padding: 10px;
      margin-top: 10px;
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      .left {
        vertical-align: middle;
        display: inline-block;
        width: 60%;
        .list-item {
          margin-bottom: 10px;
        }
        .list-item:last-child {
          margin-bottom: 0px;
        }
      }
      .right {
        vertical-align: middle;
        display: inline-block;
        width: 40%;
        .images {
          overflow: hidden;
          vertical-align: middle;
          text-align: center;
          ::v-deep img {
            border-radius: 8px;
          }
        }
      }
    }
  }
}
</style>